var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.close,
          expression: "close",
        },
      ],
      staticClass: "bg-picker",
    },
    [
      _c(
        "div",
        {
          staticClass: "sp-logo-bar w-100 bg-picker__trigger",
          on: { click: _vm.toggle },
        },
        [
          _c("button", { staticClass: "sp-logo-btn" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "15",
                  height: "15",
                  viewBox: "0 0 15 15",
                  fill: "none",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "1",
                    y: "2",
                    width: "13",
                    height: "11",
                    rx: "1.5",
                    stroke: "currentColor",
                    "stroke-width": "1.3",
                    fill: "none",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M1 9l3.5-3.5 3 3L10.5 5l3.5 4",
                    stroke: "currentColor",
                    "stroke-width": "1.3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    fill: "none",
                  },
                }),
                _vm._v(" "),
                _c("circle", {
                  attrs: { cx: "5", cy: "6", r: "1", fill: "currentColor" },
                }),
              ]
            ),
            _vm._v("\n      Add logo\n    "),
          ]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "sp-icon-btn", attrs: { title: "Add" } },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "13",
                    height: "13",
                    viewBox: "0 0 13 13",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M6.5 1v11M1 6.5h11",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "bg-picker__panel" } }, [
        _vm.isOpen
          ? _c(
              "div",
              {
                staticClass: "bg-picker__panel",
                style: _vm.panelPositionStyle,
                attrs: { role: "menu" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-between",
                  },
                  [
                    _c("p", { staticClass: "bg-picker__panel-title" }, [
                      _vm._v("\n          Logo Library\n        "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "bg-picker__option",
                        attrs: { role: "menuitem" },
                        on: { click: _vm.triggerUpload },
                      },
                      [
                        _c("span", { staticClass: "bg-picker__option-icon" }, [
                          _c("i", { staticClass: "bi bi-upload" }),
                        ]),
                        _vm._v("\n          Upload\n        "),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  ref: "fileInput",
                  staticClass: "bg-picker__file-input",
                  attrs: { type: "file", accept: "image/*" },
                  on: { change: _vm.onFileSelected },
                }),
                _vm._v(" "),
                _vm.availableLogos.length
                  ? _c(
                      "div",
                      { staticClass: "logo-list" },
                      _vm._l(_vm.availableLogos, function (logo) {
                        return _c(
                          "div",
                          { key: logo.id, staticClass: "logo-item" },
                          [
                            _c("div", { staticClass: "logo-item__thumb" }, [
                              _c("img", {
                                attrs: {
                                  src: logo.previewUrl ?? logo.thumbnail_path,
                                  alt: logo.fileName || "Logo",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.addLogo(
                                      null,
                                      null,
                                      logo.original_path ?? null
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.availableLogos.length
                  ? _c("div", { staticClass: "empty-folder" }, [
                      _c("p", [
                        _vm._v("\n          No logos yet. Click "),
                        _c("strong", [_vm._v("Upload")]),
                        _vm._v(" to add one.\n        "),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-end border-t pt-1 mt-1",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "file-browser-btn bg-picker__option",
                        attrs: {
                          title:
                            "Rename, delete, or organize logos in the File Browser",
                        },
                        on: { click: _vm.redirectToFileBrowser },
                      },
                      [
                        _c("i", { staticClass: "bi bi-folder" }),
                        _vm._v("\n          Manage in File Browser\n        "),
                      ]
                    ),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }